import React from 'react';
import clsx from 'clsx';
import styles from './Footer.module.scss';
const DefaultFooter = () => {
    return (<div className={styles.defaultFooter}>
      <a href='https://www.haven.com/support/accessibility'>Accessibility</a>
      {' | '}
      {/* eslint-disable-next-line */}
      <a href='#' className='ot-sdk-show-settings' id='fides-modal-link'>
        Manage consent
      </a>
      {' | '}
      <a href='https://www.haven.com/support/cookies-policy'>Cookies Policy</a>
      {' | '}
      <a href='https://www.haven.com/support/privacy-policy'>Privacy Policy</a>
    </div>);
};
export const Footer = ({ children, sticky }) => {
    return (<footer className={clsx(styles.footer, 'no-print', sticky && styles.stickyFooter)}>
      {children ? children : <DefaultFooter />}
    </footer>);
};
